import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "my-4" }
const _hoisted_2 = { key: 0 }

import { ref, onMounted, computed } from "vue";
import ProviderCostEstimator from "@/guiide/components/guiideplus/providers/ProviderCostEstimator.vue";
import { app } from "@/guiide/ts/app";
import { formatter } from "@/shared/ts/formatter";


export default /*@__PURE__*/_defineComponent({
  __name: 'SimpleComparison',
  setup(__props) {

onMounted(async () => {
    const providerCharges = await app.getProviderCharges();
    industryAverageCharge.value = providerCharges.industryAverage;
});

const industryAverageCharge = ref(0);
const currentProviderCharge = ref(0);
const otherProviderCharge = ref(0);

function currentProviderChargeRateChanged(chargeRate: number, cost: number) {
    currentProviderCharge.value = cost;
}

function otherProviderChargeRateChanged(chargeRate: number, cost: number) {
    otherProviderCharge.value = cost;
}

const chargeDifference = computed(() => otherProviderCharge.value - currentProviderCharge.value);
const chargeDifferenceText = computed(() => formatter.formatCurrency(Math.abs(chargeDifference.value)));
const displayChargeDifference = computed(() => chargeDifference.value != 0);
const moreOrLessText = computed(() => {
    if (chargeDifference.value == 0) {
        return "the same";
    } else if (chargeDifference.value < 0) {
        return "less";
    } else {
        return "more";
    }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[1] || (_cache[1] = _createElementVNode("h2", null, "Provider Cost Comparison", -1)),
    _cache[2] || (_cache[2] = _createElementVNode("p", { class: "mx-auto col-md-9 mb-4 lead" }, " As you built a plan we can estimate the cost of any provider charges in £ terms over the course of your whole retirement below and compare a current provider to any other. ", -1)),
    _createVNode(ProviderCostEstimator, {
      industryAverageCharge: industryAverageCharge.value,
      upperText: "Current Provider annual charges",
      onChargeRateChanged: currentProviderChargeRateChanged
    }, null, 8, ["industryAverageCharge"]),
    _createVNode(ProviderCostEstimator, {
      industryAverageCharge: industryAverageCharge.value,
      upperText: "Other Provider annual charges",
      onChargeRateChanged: otherProviderChargeRateChanged
    }, null, 8, ["industryAverageCharge"]),
    _createElementVNode("p", _hoisted_1, [
      _cache[0] || (_cache[0] = _createTextVNode(" The other Provider annual charges are ")),
      (displayChargeDifference.value)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(chargeDifferenceText.value), 1))
        : _createCommentVNode("", true),
      _createTextVNode(" " + _toDisplayString(moreOrLessText.value) + " over your retirement period alone. ", 1)
    ])
  ], 64))
}
}

})